import { render } from "./custom-variant-collection.vue?vue&type=template&id=e28188b6"
import script from "./custom-variant-collection.vue?vue&type=script&lang=js"
export * from "./custom-variant-collection.vue?vue&type=script&lang=js"

import "./custom-variant-collection.vue?vue&type=style&index=0&id=e28188b6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__